import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import { Per } from 'ep-bt-field-agent-proxy';


@Component({
  selector: 'epbt-fa-competitor-negotiation-list',
  templateUrl: './epbt-fa-competitor-negotiation-list.component.html',
  styleUrls: ['./epbt-fa-competitor-negotiation-list.component.scss']
})
export class EpbtFaCompetitorNegotiationListComponent implements OnInit {
  //default = ['Each', 'Pair', ' '];
  //selectedDefault: string = this.default[0];
  // selectedCompetitorPrice:any;
  // per:Per;

//  @Output() selectedCompetitorPriceNegotiation = new EventEmitter<any>();
  
  constructor(private epbtFaCompetitorService: EpbtFaCompetitorService) { }

  ngOnInit() {
  //  this.per = this.epbtFaCompetitorService.sellPricePers;
  }

  // onSelectionChange(selectedValue: any) {
  //   this.selectedCompetitorPrice = selectedValue;   
  //   this.selectedCompetitorPriceNegotiation.emit(this.selectedCompetitorPrice);
  // }

}
